import { create } from 'zustand';

/**
 * Global store for managing debug logs in the UI.
 */
const useDebugStore = create((set) => ({
  logs: [],
  networkLogs: [],
  isVisible: false,

  /**
   * Add a new log entry to the store.
   * @param {string} type - 'log' | 'info' | 'warn' | 'error'
   * @param {Array} args - The log arguments
   */
  addLog: (type, args) =>
    set((state) => ({
      logs: [
        {
          id: Date.now() + Math.random(),
          timestamp: new Date().toLocaleTimeString(),
          type,
          content: args
            .map((arg) => {
              if (typeof arg === 'object') {
                try {
                  return JSON.stringify(arg, null, 2);
                } catch (e) {
                  return '[Circular Object]';
                }
              }
              return String(arg);
            })
            .join(' '),
        },
        ...state.logs.slice(0, 499), // Keep last 500 logs
      ],
    })),

  /**
   * Add a new network log entry.
   */
  addNetworkLog: (log) =>
    set((state) => ({
      networkLogs: [
        {
          id: log.id || Date.now() + Math.random(),
          timestamp: new Date().toLocaleTimeString(),
          ...log,
        },
        ...state.networkLogs.slice(0, 199), // Keep last 200 requests
      ],
    })),

  /**
   * Update an existing network log (e.g., with response data).
   */
  updateNetworkLog: (id, updates) =>
    set((state) => ({
      networkLogs: state.networkLogs.map((log) =>
        log.id === id ? { ...log, ...updates } : log,
      ),
    })),

  /**
   * Clear all logs.
   */
  clearLogs: () => set({ logs: [], networkLogs: [] }),

  /**
   * Toggle the visibility of the debug overlay.
   */
  toggleVisibility: () => set((state) => ({ isVisible: !state.isVisible })),

  /**
   * Set visibility explicitly.
   */
  setVisibility: (isVisible) => set({ isVisible }),
}));

export default useDebugStore;
